import { Component, ojs, app, payload } from "modular-openscriptjs";
import { dom } from "../../../fotastart";
import { pageInfo } from "../../../helpers";
import { PAGES } from "../../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

export default class ForgotPassword extends Component {
    render(...args) {
        pageInfo(PAGES.FORGOT_PASSWORD);

        return h.Container(
            h.div(
                { class: "page-forgot-pass py-md-5" },
                h.div(
                    { class: "container" },
                    h.div(
                        { class: "col-md-8 col-lg-6 py-3 px-lg-3 mx-auto" },
                        h.h4({ class: "mb-3" }, "Forgot Password"),
                        h.p(
                            { class: "mb-3" },
                            "Forgot your password? No problem. Just let us know your email address and we will email you a password reset link allowing you to choose a new one."
                        ),
                        h.div(
                            { class: "form-field required-field mb-3" },
                            h.label(
                                {
                                    class: "info-title mb-2",
                                    for: "email",
                                },
                                "Email Address"
                            ),
                            h.input({
                                type: "email",
                                name: "email",
                                class: "form-control unicase-form-control text-input",
                                id: "email",
                            })
                        ),
                        h.button(
                            {
                                type: "button",
                                onclick: this.method("submit"),
                                class: "btn-upper btn btn-primary mb-5",
                            },
                            "Email Password Reset Link"
                        )
                    )
                )
            ),

            ...args
        );
    }

    submit() {
        let email = dom.id("email")?.value;

        broker.broadcast($e.user.needs.password.link, payload({ email }));
    }
}

ojs(ForgotPassword);
